import { Machine, MachineOptions, EventObject, assign } from 'xstate'

export interface alertMachineContext {
  content?: string | JSX.Element
  confirmText?: string | JSX.Element
}

export interface alertMachineStates {
  states: {
    idle: {}
    showing: {}
    confirmed: {}
    processing: {}
    cancelled: {}
  }
}

export interface alertMachineEvents extends EventObject {
  types:
    | 'LOAD'
    | 'SHOW'
    | 'RESET'
    | 'CONFIRM'
    | 'PROCESSING'
    | 'ABORT_CONFIRM'
    | 'CANCEL'
}

const machineOptions: Partial<
  MachineOptions<alertMachineContext, alertMachineEvents>
> = {
  actions: {
    setContent: assign((__context: any, event: any) => ({
      content: event.content,
      confirmText: event.confirmText ?? __context.confirmText,
    })),
    resetContents: () => ({
      content: undefined,
    }),
  },
}

export const alertMachine = Machine<
  alertMachineContext,
  alertMachineStates,
  alertMachineEvents
>(
  {
    id: 'alertMachine',
    initial: 'idle',
    context: {
      content: undefined,
      confirmText: 'OK',
    },
    states: {
      idle: {
        on: {
          CREATE: {
            target: 'showing',
            actions: ['setContent'],
          },
        },
      },
      showing: {
        on: {
          PROCESSING: {
            target: 'processing',
          },
          CONFIRM: {
            target: 'confirmed',
          },
          CANCEL: {
            target: 'cancelled',
          },
        },
      },
      processing: {
        on: {
          CONFIRM: {
            target: 'confirmed',
          },
          ABORT_CONFIRM: {
            target: 'showing',
          },
        },
      },
      confirmed: {},
      cancelled: {},
    },
    on: {
      RESET: {
        target: 'idle',
        actions: ['resetContents'],
      },
    },
  },
  machineOptions
)
